import { h } from 'preact';
import { LoadMoreButtonPlaceholder } from '../infinite-scroll/InfiniteScroll';
import styles from './Layout.module.scss';
export function Layout({ layout, onToggleLayout, sidebar, main, showLayoutToggle, loadMoreButton, loading = false, showSidebar = true, }) {
    return (h("div", { className: styles.container },
        showLayoutToggle && (h("div", { className: styles.toolbar },
            h("button", { onClick: onToggleLayout, className: styles.toggleBtn },
                "Switch to ",
                layout === 'grid' ? 'List' : 'Grid',
                " View"))),
        h("div", { className: styles.layoutBody },
            showSidebar && h("aside", { className: styles.sidebar }, sidebar),
            h("main", { className: styles.main, "data-layout": layout }, main)),
        loadMoreButton ? (h("div", { className: styles.loadMoreSection }, loadMoreButton)) : loading ? (h("div", { className: styles.loadMoreSection },
            h(LoadMoreButtonPlaceholder, null))) : null));
}
